import { Component, Input, OnInit } from '@angular/core';
import { Configurations } from 'app/configurations/shared/configurations.model';
import { JSONEditorOptions } from 'jsoneditor';
import { CONFIGURATIONS_ACTION } from 'app/configurations/configurations-detail/configurations-detail.component';


@Component({
  selector: 'app-configurations-json',
  templateUrl: './configurations-json.component.html',
  styleUrls: ['./configurations-json.component.scss']
})
export class ConfigurationsJsonComponent implements OnInit {
  @Input() data: Configurations = {id: '', data: []};
  @Input() mode: CONFIGURATIONS_ACTION;

  public modeCheck: any = CONFIGURATIONS_ACTION;
  public isEdit: boolean;

  constructor() { }

  ngOnInit() { }

  onChange(value) {
    if (Object.keys(value).length) {
      this.data.data = value;
    }
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/configurations-json/configurations-json.component.ts